import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

interface SubPageDataContext {
  nosotrosData: NosotrosSectionProps
}

interface ImagesProps {
  head: string;
  line: string;
  plane: string;
  doll: string;
  parasuit: string;
  frame: string;
  bee: string;
  main: string;
  mision: string;
  vision: string;
}

interface MainProps {
  toptitle: string;
  title: string;
  description: string;
}

interface InfoProps {
  title: string;
  fundacion: string;
  fundacion_res: string;
  horario: string;
  horario_res: string;
  profesores: string;
  profesores_res: string;
  estudiantes: string;
  estudiantes_res: string;
  certificaciones: string;
  certificaciones_res: string;
  asistentes: string;
  asistentes_res: string;
}

interface MisionProps {
  toptitle: string;
  title: string;
  description: string;
  title_right: string;
  item1: string;
  item2: string;
  item3: string;
  item4: string;
  item5: string;
  item6: string;
}

interface VisionProps {
  toptitle: string;
  title: string;
  description: string;
}

interface NosotrosSectionProps {
  title: string;
  subtitle: string;
  description?: string;
  main: MainProps;
  info: InfoProps;
  mision: MisionProps;
  vision: VisionProps;
  images: ImagesProps;
}

const KidsaNosotros = () => {
  const { nosotrosData } = useOutletContext<SubPageDataContext>();
  const {
    title,
    main,
    info,
    mision,
    vision,
    images,
  } = nosotrosData;

  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (hash) {
        const id = hash.substring(1);
        const element = document.getElementById(id);
        if (element) {
          let offset = 0;
          
          switch(id) {
            case 'historia':
              offset = 80; // Ajusta según necesites
              break;
            case 'mision':
              offset = 120; // Ajusta según necesites
              break;
            case 'vision':
              offset = 120; // Ajusta según necesites
              break;
            case 'directora':
              offset = 120; // Mayor offset para directora que tenía el problema
              break;
            default:
              offset = 80; // Offset por defecto para cualquier otra sección
          }
          
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    };

    // Pequeño delay para asegurar que la página esté completamente cargada
    const timer = setTimeout(scrollToHash, 100);
    
    const handleHashChange = () => {
      scrollToHash();
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <>
    <div className="breadcrumb-wrapper hero-1 bg-cover">
    <div className="bottom-shape">
      <img src={images.head} />
    </div>
      <div className="line-shape">
        <img src={images.line} alt="shape-img" />
      </div>
      <div className="plane-shape float-bob-y">
        <img src={images.plane} alt="shape-img" />
      </div>
      <div className="doll-shape float-bob-x">
        <img src={images.doll} alt="shape-img" />
      </div>
      <div className="parasuit-shape float-bob-y">
        <img src={images.parasuit} alt="shape-img" />
      </div>
      <div className="frame-shape">
        <img src={images.frame} alt="shape-img" />
      </div>
      <div className="bee-shape float-bob-x">
        <img src={images.bee} alt="shape-img" />
      </div>
      <div className="container">
        <div className="nosotros">
          <h1 className="wow fadeInUp" data-wow-delay=".3s">{title}</h1>
        </div>
      </div>
    </div>

    <section id="historia" className="program-details-section">
      <div className="container">
        <div className="program-details-wrapper">
          <div className="row g-5">
            <div className="col-lg-8">
              <div className="program-details-items">
                <div className="details-image">
                  <img src={images.main} alt="img" />
                </div>
                <div className="details-content details-list-area">
                  <div className="post">
                    <span>{main.toptitle}</span>
                  </div>
                  <h2 className="mb-2">{main.title}</h2>
                  <p className="mb-3">
                    {main.description}
                  </p>
                  <p className="mb-4">
                    
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="details-list-area">
                <h3>{info.title}</h3>
                <ul className="details-list">
                  <li>
                    <span>
                      <i className="fa-solid fa-chart-simple me-2"></i>
                      {info.fundacion}
                    </span>
                    {info.fundacion_res}
                  </li>
                  <li>
                    <span>
                      <i className="fa-regular fa-clock me-2"></i>
                      {info.horario}
                    </span>
                    {info.horario_res}
                  </li>
                  <li>
                    <span>
                      <i className="fal fa-book-spells me-2"></i>
                      {info.profesores}
                    </span>
                    {info.profesores_res}
                  </li>
                  <li>
                    <span>
                      <i className="fas fa-users-class me-2"></i>
                      {info.estudiantes}
                    </span>
                    {info.estudiantes_res}
                  </li>
                  <li>
                    <span>
                      <i className="fas fa-certificate me-2"></i>
                      {info.certificaciones}
                    </span>
                    {info.certificaciones_res}
                  </li>
                  <li>
                    <span>
                      <i className="fas fa-globe me-2"></i>
                      {info.asistentes}
                    </span>
                    {info.asistentes_res}
                  </li>
                </ul>
                <a href="./" className="theme-btn w-100">
                  Volver al Inicio <i className="fa-solid fa-arrow-right-long"></i>
                </a>
                <div className="social-icon d-flex align-items-center">
                  <span>Síguenos: </span>
                  <a href="#"><i className="fab fa-instagram"></i></a>
                  <a href="#"><i className="fab fa-facebook"></i></a>
                  <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                  <a href="#"><i className="fa-brands fa-youtube"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="mision" className="program-details-section fix section-padding">
      <div className="container">
        <div className="program-details-wrapper">
          <div className="row g-5">
            <div className="col-lg-8">
              <div className="program-details-items">
                <div className="details-image">
                  <img src={images.mision} alt="img" />
                </div>
                <div className="details-content details-list-area">
                  <div className="post">
                    <span>{mision.toptitle}</span>
                  </div>
                  <h2 className="mb-2">{mision.title}</h2>
                  <p className="mb-3">
                    {mision.description}
                  </p>
                  <p className="mb-4">
                    
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="details-list-area">
                <h3>{mision.title_right}</h3>
                <ul className="list-items mision">
                    <li>
                      <i className="fa-solid fa-check mx-2"></i>
                      {mision.item1} 
                    </li>
                    <li>
                      <i className="fa-solid fa-check mx-2"></i>
                      {mision.item2} 
                    </li>
                    <li>
                      <i className="fa-solid fa-check mx-2"></i>
                      {mision.item3}
                    </li>
                    <li>
                      <i className="fa-solid fa-check mx-2"></i>
                      {mision.item4} 
                    </li>
                    <li>
                      <i className="fa-solid fa-check mx-2"></i>
                      {mision.item5} 
                    </li>
                    <li>
                      <i className="fa-solid fa-check mx-2"></i>
                      {mision.item6} 
                    </li>
                  </ul>
                <a href="./" className="theme-btn w-100">
                  Volver al Inicio <i className="fa-solid fa-arrow-right-long"></i>
                </a>
                <div className="social-icon d-flex align-items-center">
                  <span>Síguenos: </span>
                  <a href="#"><i className="fab fa-instagram"></i></a>
                  <a href="#"><i className="fab fa-facebook"></i></a>
                  <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                  <a href="#"><i className="fa-brands fa-youtube"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="vision" className="program-details-section fix section-padding">
            <div className="container">
                <div className="team-details-wrapper">
                    <div className="team-author-items">
                        <div className="thumb">
                            <img src={images.vision} alt="img" />
                        </div>
                        <div className="content">
                        
                    <span className="post">{vision.toptitle}</span>
                            <h2>{vision.title}</h2>
                            <span></span>
                            <p>
                              {vision.description}
                            </p>
                        </div>
                    </div>
                  </div>
                </div>
    </section>

   <section id="directora" className="about-section section-padding pt-0">
      <div className="left-shape">
        <img src="/assets/kidsa/assets/img/about/left-shape.png" alt="shape-img" />
      </div>
      <div className="plane-shape float-bob-y">
        <img src="/assets/kidsa/assets/img/plane.png" alt="shape-img" />
      </div>
      <div className="line-1">
        <img src="/assets/kidsa/assets/img/line-1.png" alt="shape-img" />
      </div>
      <div className="container">
        <div className="about-wrapper-3">
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="about-image-area">
                <div className="radius-shape">
                  <img src="/assets/kidsa/assets/img/about/radius-shape.png" alt="shape-img" />
                </div>
                <div className="circle-shape">
                  <img src="/assets/kidsa/assets/img/about/circle.png" alt="shape-img" />
                </div>
                <div className="about-image">
                  <img src="/assets/kidsa/assets/img/about/03.jpg" alt="about-img" className="wow fadeInUp" data-wow-delay=".3s" />
                    <div className="about-image-2 wow fadeInLeft" data-wow-delay=".5s">
                      {/*<img src="/assets/kidsa/assets/img/about/07.png" alt="about-img" />*/}
                    </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-content">
                <div className="section-title">
                  <span className="wow fadeInUp">Palabras de la Directora</span>
                  <h2 className="wow fadeInUp" data-wow-delay=".3s">Bienvenidas y bienvenidos al sitio web de nuestro querido colegio.</h2>
                </div>
                                <p className="mt-3 mt-md-0 wowx fadeInUp" data-wow-delay=".5s">
                                    Como directora, es un honor darles la más cálida bienvenida a esta comunidad educativa que, con orgullo, forma parte de la educación pública y rural de nuestro país. Somos un colegio que se levanta día a día con esfuerzo, convicción y esperanza, guiados por el profundo sentido de la vocación docente y el compromiso con cada uno de nuestros niños y niñas.
                                </p>
                                <p className="mt-3 mt-md-0 wowx fadeInUp" data-wow-delay=".5s">
                                    Nuestro colegio es un espacio vivo, donde la naturaleza no solo nos rodea, sino que también nos educa. Con un sello medioambientalista fuerte, promovemos una conciencia ecológica activa, respetuosa y transformadora, que se refleja en cada rincón del colegio y en el quehacer diario de nuestros estudiantes, asistentes y docentes.
                                </p>
                                <p className="mt-3 mt-md-0 wowx fadeInUp" data-wow-delay=".5s">
                                    Creemos firmemente en la inclusión como un principio y una práctica. Cada estudiante es valorado en su individualidad, con sus talentos, ritmos y desafíos. Por eso, trabajamos para que todos y todas encuentren aquí un lugar seguro, estimulante y acogedor, donde se sientan parte de una comunidad que los reconoce y acompaña en su crecimiento integral.
                                </p>
                                <p className="mt-3 mt-md-0 wowx fadeInUp" data-wow-delay=".5s">
                                    Nuestro proyecto educativo se construye desde la identidad, con raíces profundas en nuestra historia local, nuestras tradiciones y el entorno natural que nos cobija. Pero también con una mirada puesta en el futuro, preparando ciudadanos conscientes, críticos, solidarios y comprometidos con la vida en sociedad.
                                </p>
                                <p className="mt-3 mt-md-0 wowx fadeInUp" data-wow-delay=".5s">
                                  En nuestro colegio se respira un ambiente de armonía y afecto. Porque educar no es solo enseñar contenidos, sino también formar con cariño, con respeto y con presencia. Nos esforzamos cada día por construir relaciones significativas entre todos los actores de la comunidad educativa: estudiantes, familias, docentes, asistentes y directivos.
                                </p>
                                <p className="mt-3 mt-md-0 wowx fadeInUp" data-wow-delay=".5s">
                                  Como directora, pongo a disposición toda mi experiencia, energía y amor por esta labor, con la certeza de que la educación puede transformar vidas y abrir caminos de esperanza, especialmente en contextos como el nuestro. Los invito a conocer nuestro colegio, a sumarse con entusiasmo y a creer, como nosotros, que una educación pública de calidad, humana y comprometida sí es posible.
                                </p>
                                
                                <div className="about-author">
                                    <div className="author-image wow fadeInUp" data-wow-delay=".5s">
                                        <div className="contentx">
                                          Con afecto y convicción,
                                            <h6>Laura Gómez Alarcón</h6>
                                            <p>Directora</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>
    </>
  );
};

export default KidsaNosotros;